function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "speed");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("polygon", {
  points: "4.02 12.68 4.02 35.99 23.92 47.27 44.35 35.88 44.35 12.68 4.02 12.68"
}), React.createElement("polyline", {
  points: "4.02 12.68 23.92 47.27 23.92 24.28 44.35 12.68 24.19 1.19 4.02 12.68 23.92 24.28"
}), React.createElement("line", {
  x1: 23.92,
  y1: 47.27,
  x2: 44.35,
  y2: 12.68
}));

var SvgFigure2 = function SvgFigure2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    width: 48.38,
    height: 48.38,
    viewBox: "0 0 48.38 48.38",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFigure2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figure-2.9680f825.svg";
export { ForwardRef as ReactComponent };